<div class="instructor-header default flex bg-slate-800 py-3 px-6 text-white">
  <div class="flex grow justify-between">
    <div class="left-content flex flex-row items-center gap-3">
      <span (click)="headerAction()" class=" bg-slate-700 w-11 h-11 flex items-center justify-center text-slate-300 rounded-sm cursor-pointer lg:hidden">
        <svg-icon [src]="isSidebar ? '@assets/images/icons/x-mark.svg' : '@assets/images/icons/bars-3.svg'" class="ar:rotate-180 h-6 w-6"></svg-icon>
      </span>
      <a routerLink="/">
        <svg-icon src="@assets/images/logo-white.svg" class="block h-7 w-auto"></svg-icon>
      </a>
    </div>
    <div class="right-content">
      <ng-container *ngTemplateOutlet="defaultRight">
        <ng-content select="[right]"></ng-content>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #defaultRight>
  <div class="userinfo">
    <!-- Account Buttons -->
    <div class="flex items-center justify-start gap-3">
      <a class="hidden lg:block">
        <button (click)="switchToStudent()" class="btn btn-dark hover:bg-slate-700">
          <span i18n>Switch to Student</span>
        </button>
      </a>
      <!-- <button type="button" class="btn btn-dark px-2">
        <svg-icon class="h-5 w-5" src="@assets/images/icons/bell.svg"></svg-icon>
      </button> -->
      <ng-container *ngIf="{ userAuthInfo: userAuthInfo$ | async } as vm">
      <!-- Menu -->
        <div class="account-menu">
          <app-navigation position="right">
            <ng-container button>
              <thk-avatar class="ltr:ml-2 rtl:mr-2" [title]="fullName" [url]="photoUrl"></thk-avatar>
            </ng-container>
            <ng-container header>
              <div class="heading flex items-center gap-4 p-4">
                <thk-avatar [title]="fullName" [url]="photoUrl"></thk-avatar>
                <div>
                  <div class="name font-medium">{{fullName}}</div>
                  <div class="email text-xs text-slate-500">{{userEmail}}</div>
                </div>
              </div>
            </ng-container>
            <ng-container content>
              <div class="content max-h-[400px] overflow-y-auto border-y border-y-slate-300">
                <ul class="account-items border-b border-b-slate-300">
                  <li class="relative">
                    <a routerLink="/student/dashboard" i18n>Student</a>
                  </li>
                </ul>
                <ul class="account-items">
                  <li class="relative">
                    <a routerLink="/instructor-profile/{{instructorId}}" i18n>Public profile</a>
                  </li>
                  <li class="relative">
                    <a routerLink="/student/account/profile" [queryParams]="{edit: true}" i18n>Edit profile</a>
                  </li>
                </ul>
              </div>
            </ng-container>
            <ng-container footer>
              <div class="footer">
                <ul class="account-items">
                  <li class="relative">
                    <a href="https://support.thkee.com/hc/en-us" target="_blank" i18n>Help</a>
                  </li>
                  <li class="relative">
                    <a class="rounded-b-lg cursor-pointer" (click)="logout()" i18n>Logout</a>
                  </li>
                </ul>
              </div>
            </ng-container>
          </app-navigation>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
